import {useState} from "react";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {ETAPService} from "abastecemento/service";
import {etap_view_adapter} from "abastecemento/model";
import {EntityCreatePage} from "base/entity";
import {ETAPForm} from "../presentational/form";

const CreateETAPPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const basePath = location.pathname.split("/new")[0];
    const {codigo} = useParams();
    const codigoConcello = codigo;

    const [error, setError] = useState("");

    const handleFormSubmit = etap => {
        ETAPService.create(etap_view_adapter({...etap}))
            .then(createdEtap => {
                navigate(`${basePath}/${createdEtap.id}/summary`);
            })
            .catch(error => {
                setError(error);
            });
    };

    const handleFormCancel = () => {
        navigate(basePath);
    };

    return (
        <EntityCreatePage
            form={
                <ETAPForm
                    onSubmit={handleFormSubmit}
                    onCancel={handleFormCancel}
                    concello={codigoConcello}
                />
            }
            title="Rexistro de ETAP"
            error={error}
        />
    );
};

export default CreateETAPPage;
